module.exports = __webpack_public_path__ + "static/why-popup--2-e0e75cbe111ae4a3b8e65bffbd5d9bd3.png";